import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    beingActivatedItems: [],
    beingDeletedItems: [],
    priceListEditDialog: {
        open: false,
        priceListId: undefined,
        initialIsFtpVerified: undefined,
        pendingEmailsInputValue: '',
        pendingScheduleTimeInputValue: '',
    },
    linkedPriceListDialog: {
        open: false,
        selectedSupplierPriceLists: [],
        selectedExportPriceListIds: [],
    },
};
const priceListSlice = createSlice({
    name: 'priceList',
    initialState,
    reducers: {
        addItemToBeingActivated: (state, action) => {
            state.beingActivatedItems.push(action.payload);
        },
        removeItemFromBeingActivated: (state, action) => {
            state.beingActivatedItems = state.beingActivatedItems.filter((item) => item !== action.payload);
        },
        addItemToBeingDeleted: (state, action) => {
            state.beingDeletedItems.push(action.payload);
        },
        removeItemFromBeingDeleted: (state, action) => {
            state.beingDeletedItems = state.beingDeletedItems.filter((item) => item !== action.payload);
        },
        openPriceListEditDialog: (state, action) => {
            state.priceListEditDialog.open = true;
            state.priceListEditDialog.priceListId = action.payload?.priceListId;
        },
        closePriceListEditDialog: (state) => {
            state.priceListEditDialog = initialState.priceListEditDialog;
        },
        setPendingEmailsInputValue: (state, action) => {
            state.priceListEditDialog.pendingEmailsInputValue = action.payload.trim();
        },
        setPendingScheduleTimeInputValue: (state, action) => {
            state.priceListEditDialog.pendingScheduleTimeInputValue = action.payload.trim();
        },
        setInitialIsFtpVerified: (state, action) => {
            state.priceListEditDialog.initialIsFtpVerified = action.payload;
        },
        openLinkedPriceListDialog: (state) => {
            state.linkedPriceListDialog.open = true;
        },
        closeLinkedPriceListDialog: (state) => {
            state.linkedPriceListDialog = initialState.linkedPriceListDialog;
        },
        toggleUnlinkedSupplierPriceList: (state, action) => {
            const { priceListId, checked, markup } = action.payload;
            if (checked) {
                if (!state.linkedPriceListDialog.selectedSupplierPriceLists.some((item) => item.priceListId === priceListId)) {
                    state.linkedPriceListDialog.selectedSupplierPriceLists.push({ priceListId, markup });
                }
            }
            else {
                state.linkedPriceListDialog.selectedSupplierPriceLists = state.linkedPriceListDialog.selectedSupplierPriceLists.filter((item) => item.priceListId !== priceListId);
            }
        },
        toggleUnlinkedExportPriceList: (state, action) => {
            const { exportPriceListId, checked } = action.payload;
            if (checked) {
                if (!state.linkedPriceListDialog.selectedExportPriceListIds.includes(exportPriceListId)) {
                    state.linkedPriceListDialog.selectedExportPriceListIds.push(exportPriceListId);
                }
            }
            else {
                state.linkedPriceListDialog.selectedExportPriceListIds = state.linkedPriceListDialog.selectedExportPriceListIds.filter((el) => el !== exportPriceListId);
            }
        },
        setUnlinkedSupplierPriceListMarkup: (state, action) => {
            const { priceListId, markup } = action.payload;
            const index = state.linkedPriceListDialog.selectedSupplierPriceLists.findIndex((item) => item.priceListId === priceListId);
            if (index !== -1)
                state.linkedPriceListDialog.selectedSupplierPriceLists[index].markup = markup;
        },
    },
    // TODO: to delete later
    // extraReducers: (builder) => {
    // 	builder.addCase(updateExportPriceList.fulfilled, (state) => {
    // 		state.priceListEditDialog = initialState.priceListEditDialog;
    // 	});
    // },
});
export const { actions: priceListActions, reducer: priceListReducer } = priceListSlice;
